import React from "react";
import { Slice } from "gatsby";
import PropTypes from "prop-types";

export const DefaultLayout = ({
  children,
  headerClassName,
  footerClassName,
}) => {
  return (
    <div className="body">
      <Slice alias="header" className={headerClassName} />
      {children}
      <Slice alias="footer" className={footerClassName} />
    </div>
  );
};

DefaultLayout.propTypes = {
  children: PropTypes.string,
  headerClassName: PropTypes.string,
  footerClassName: PropTypes.string,
};
